import type { Company } from '../../Companies/Types/companyTypes';

export interface BankDocumentCompanyLookup {
  id: number;
  name: string;
}

export const mapCompanyToBankDocumentLookup = (
  company: Company | undefined | null
): BankDocumentCompanyLookup | undefined => {
  if (!company) {
    return undefined;
  }

  return {
    id: company.id,
    name: company.name,
  };
};
